<template>
    <DialogBase class="dialog-history">

        <template #title>
            Prompt History
        </template>

        <template #content>

            <div v-if="!isSynchronized">
                <span>Loading history...</span>
            </div>
            <div v-else-if="hasPrompts">
                <span>Select a recent prompt to insert it.</span>
                <br /><br />
                <v-list color="color1">
                    <v-list-item 
                        v-for="(prompt, index) in getRecentPrompts" 
                        :key="index" 
                        @click="handleSelect(prompt)">
                        <span class="prompt">"{{ prompt }}"</span>
                    </v-list-item>
                </v-list>
            </div>
            <div v-else>
                <span>History does not contain any prompts.</span>
            </div>

        </template>

        <template #actions>
            <v-btn 
                variant="elevated" 
                elevation="2" 
                color="surface"
                @click="handleClose">
                Close
            </v-btn>
        </template>

    </DialogBase>
</template>

<script>
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { DialogBase } from '@generio-ai/library-legacy/components/dialogs'

export default {
    name: 'DialogHistory',
    components: {
        DialogBase
    },
    props: {
        card: {
            type: Object,
            required: true
        },
    },
    computed: {
        ...mapGetters('assets', [
            'isSynchronized'
        ]),
        ...mapGetters('library', [
            'getRecentPrompts'
        ]),
        hasPrompts() {
            return this.getRecentPrompts && this.getRecentPrompts.length > 0
        }
    },
    methods: {
        ...mapActions('dialogs', [
            'close'
        ]),
        handleSelect(prompt)
        {
            this.card.prompt.user = prompt
            this.close()
        },
        handleClose()
        {
            this.close()
        }
    }
}
</script>

<style scoped>
.dialog-history .prompt {
    text-transform: none;
}
</style>